import React from 'react';

import Text from '/component/base/Text';

import {styles} from './Heading.style';

interface HeadingProps {
  level: 1 | 2 | 3;
  children: React.ReactNode;
}

export const Heading: React.FC<HeadingProps> = ({
  level = 1,
  children = 'Heading',
}) => {
  const style = [styles.base];

  if (level === 1) {
    // @ts-expect-error TS(2345): Argument of type '{ fontSize: number; fontWeight: ... Remove this comment to see the full error message
    style.push(styles.level1);
  } else if (level === 2) {
    // @ts-expect-error TS(2345): Argument of type '{ fontSize: number; fontWeight: ... Remove this comment to see the full error message
    style.push(styles.level2);
  } else if (level === 3) {
    // @ts-expect-error TS(2345): Argument of type '{ fontSize: number; fontWeight: ... Remove this comment to see the full error message
    style.push(styles.level3);
  }

  return <Text style={style}>{children}</Text>;
};

export default Heading;
